import classNames from 'classnames';
import { t } from 'ttag';

import Title from '@ui/Title';
import { Button } from '@ui/Button';
import {
  Modal,
  ModalProps,
} from '@ui/Modal';

import s from './PaymentMethodErrorModal.sss';

type Props = ModalProps & {
  text: string
};

export const PaymentMethodErrorModal: React.FC<Props> = ({
  text,
  onRequestClose,
  ...props
}) => (
  <Modal
    {...props}
    onRequestClose={onRequestClose}
    className={classNames(s.root, props.className)}
  >
    <Title type="h3" bold={false}>{t`Спосіб оплати`}</Title>

    <p className={s.text}>
      {text}
    </p>

    <Button
      className={s.button}
      onClick={onRequestClose}
    >
      {t`Добре`}
    </Button>
  </Modal>
);
